document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-nike-open-filters]');
  if (!btn) return;
  document.querySelector('menu-drawer.mobile-facets__wrapper summary')?.click();
});

function mountNikeActiveFacets() {
  const slot = document.getElementById('NikeActiveFacetsSlot');
  const facets = document.getElementById('NikeActiveFacets');
  if (!slot || !facets) return;

  // Mover (si no está ya)
  if (facets.parentElement !== slot) slot.appendChild(facets);
}

document.addEventListener('DOMContentLoaded', () => {
  mountNikeActiveFacets();

  // Re-montar cuando Dawn refresca filtros por AJAX
  const obs = new MutationObserver(() => mountNikeActiveFacets());
  obs.observe(document.documentElement, { childList: true, subtree: true });
});